import { BaseComponent } from "../BaseComponent";
import { ComponentNames } from 'src/app/helper/componentNames';
import { InteriorObject } from '../../interior-object.model';

export class ContainerBaseComponent extends BaseComponent {
    constructor(){
        super();
        this.componentType = ComponentNames.containerBaseComponent;
    }
    WallThickness:number;
    Walls:InteriorObject[];
}

